import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=a058d090&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=a058d090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a058d090",
  null
  
)

export default component.exports